import React from 'react';
import PropTypes from 'prop-types';
import HoverMenu from './hover-menu/hover-menu';
import HoverMenuItem from './hover-menu/hover-menu-item';
import HoverMenuItemSeparator from './hover-menu/hover-menu-separator';
import { getMenuGaAttributes } from './site-header.analytics.js';
import { useTranslator, useUrlLocalizer } from 'tradera-lang/translate';

import AuctionIcon from '@tradera/blueprint/theme/icons2/auction.svg?jsx';
import AuctionLostIcon from '@tradera/blueprint/theme/icons2/bid-lost.svg?jsx';
import WinningIcon from '@tradera/blueprint/theme/icons2/winning.svg?jsx';
import RatingPositiveIcon from '@tradera/blueprint/theme/icons2/rating-positive.svg?jsx';

const getGaAttributes = label =>
    getMenuGaAttributes('Top navigation', 'Buying menu', label);

const BuyMenu = ({ showMenu }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <HoverMenu showMenu={showMenu} className="hover-buy-menu">
            <HoverMenuItem
                label={t('siteHeader_ongoingAuctions')}
                link={toLocalizedUrl('/my/active-items')}
                icon={<AuctionIcon className="icon" />}
                gaAttributes={getGaAttributes('Ongoing auctions')}
            />
            <HoverMenuItem
                label={t('siteHeader_boughtItems')}
                link={toLocalizedUrl('/my/purchases')}
                icon={<WinningIcon className="icon" />}
                gaAttributes={getGaAttributes('Won / Bought')}
            />
            <HoverMenuItem
                label={t('siteHeader_lostAuctions')}
                link={toLocalizedUrl('/my/items-lost')}
                icon={<AuctionLostIcon className="icon" />}
                gaAttributes={getGaAttributes('Lost')}
            />
            <HoverMenuItemSeparator />
            <HoverMenuItem
                label={t('siteHeader_rateSeller')}
                link={toLocalizedUrl(
                    '/my/leave-feedback/buyer?transactionId=0'
                )}
                icon={<RatingPositiveIcon className="icon" />}
                gaAttributes={getGaAttributes('Rate seller')}
            />
        </HoverMenu>
    );
};

BuyMenu.propTypes = {
    showMenu: PropTypes.bool
};

export default BuyMenu;
